import React from 'react';
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Working.css";

gsap.registerPlugin(ScrollTrigger);

export const Working = () => {
  const sectionRef = useRef(null);
  const stepRefs = useRef([]);
  const lineRefs = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      stepRefs.current.forEach((step, index) => {
        gsap.fromTo(
          step,
          { opacity: 0, scale: 0.8 },
          {
            opacity: 1,
            scale: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: step,
              start: "center center",
              toggleActions: "play none none reverse",
            },
          }
        );
      });

      lineRefs.current.forEach((line, index) => {
        gsap.fromTo(
          line,
          { scaleX: 0 },
          {
            scaleX: 1,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: {
              trigger: stepRefs.current[index],
              start: "center center",
              toggleActions: "play none none reverse",
              transformOrigin: "left",
            },
          }
        );
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return React.createElement(
    "section",
    { className: "how-it-works", ref: sectionRef },
    React.createElement(
      "div",
      { className: "heading" },
      React.createElement("h4", null, "Why us ?"),
      React.createElement(
        "h3",
        null,
        "Building Trust Through ",
        React.createElement("span", null, "Every Engineered Part")
      )
    ),
    React.createElement(
      "section",
      { className: "steps" },
      React.createElement(
        "div",
        {
          className: "step step1",
          ref: (el) => (stepRefs.current[0] = el),
        },
        React.createElement(
          "div",
          { className: "icon" },
          React.createElement("i", { className: "ri-map-pin-fill" })
        ),
        React.createElement(
          "div",
          { className: "step-text" },
          React.createElement("h5", null, "Unmatched Quality"),
          React.createElement(
            "p",
            null,
            "Our products are crafted with precision, ensuring high-performance and long-lasting reliability for every vehicle."
          )
        )
      ),
      React.createElement("div", {
        className: "line",
        ref: (el) => (lineRefs.current[0] = el),
      }),
      React.createElement(
        "div",
        {
          className: "step step2",
          ref: (el) => (stepRefs.current[1] = el),
        },
        React.createElement(
          "div",
          { className: "icon" },
          React.createElement("i", { className: "ri-calendar-schedule-fill" })
        ),
        React.createElement(
          "div",
          { className: "step-text" },
          React.createElement("h5", null, "Trusted by Experts"),
          React.createElement(
            "p",
            null,
            "Professionals and enthusiasts trust Motatec Asia for premium parts, offering peace of mind with every purchase."
          )
        )
      ),
      React.createElement("div", {
        className: "line",
        ref: (el) => (lineRefs.current[1] = el),
      }),
      React.createElement(
        "div",
        {
          className: "step step3",
          ref: (el) => (stepRefs.current[2] = el),
        },
        React.createElement(
          "div",
          { className: "icon" },
          React.createElement("i", { className: "ri-bookmark-3-fill" })
        ),
        React.createElement(
          "div",
          { className: "step-text" },
          React.createElement("h5", null, "Engineered to Perfection"),
          React.createElement(
            "p",
            null,
            "Every part is developed under our brand with precision, ensuring top-tier performance and reliability."
          )
        )
      )
    )
  );
};
